import gameNames from '../../hub/data/GameIds';

const initialState = {
  // array of items to be reduced in size;
  smallItemsIds: [],
};

const smallItemsReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'REDUCE_ITEMS_SIZE':
      return { ...state, smallItemsIds: action.payload.smallItemsIds };
    case 'RESET_SMALL_ITEMS':
      return { smallItemsIds: [] };
    default:
      return state;
  }
};

export default smallItemsReducer;
